import apiClient from '../../shared/services/apiClient';

/**
 * 邮件推送（TM）管理后台 — /api/admin/tm/*（见 api/docs/tm-architecture.md）。
 * 返回后端 body；HTTP 错误时抛出 {success:false, error, status, ...body}。
 */
const BASE = '/api/admin/tm';

const call = async (p) => {
    try {
        const res = await p;
        return res.data;
    } catch (e) {
        const body = e?.response?.data || {};
        // eslint-disable-next-line no-throw-literal
        throw { ...body, success: false, status: e?.response?.status, error: body.error || body.message || e?.message };
    }
};
const get = (url, params) => call(apiClient.get(`${BASE}${url}`, { params }));
const post = (url, data, cfg = {}) => call(apiClient.post(`${BASE}${url}`, data || {}, cfg));

const tmAdminService = {
    // 发信流
    listStreams: (params) => get('/streams', params),
    getStream: (id) => get(`/streams/${id}`),
    pauseStream: (id, reason) => post(`/streams/${id}/pause`, { reason }),
    resumeStream: (id) => post(`/streams/${id}/resume`),
    banStream: (id, reason) => post(`/streams/${id}/ban`, { reason }),
    unbanStream: (id) => post(`/streams/${id}/unban`),
    releaseSandbox: (id) => post(`/streams/${id}/release-sandbox`),
    setStreamGroup: (id, groupId) => post(`/streams/${id}/set-group`, { group_id: groupId ?? null }),
    createInternalStream: (data) => post('/streams/create-internal', data),
    // 信用等级
    getTrust: (userId) => get('/trust', { user_id: userId }),
    setTrust: (userId, data) => post(`/trust/${userId}/set`, data),

    // 节点
    listNodes: () => get('/nodes'),
    createNode: (data) => post('/nodes/create', data),
    updateNode: (id, data) => post(`/nodes/${id}/update`, data),
    rotateNodeSecret: (id) => post(`/nodes/${id}/rotate-secret`),
    deleteNode: (id) => post(`/nodes/${id}/delete`),
    nodeHealth: (id) => post(`/nodes/${id}/health`, {}, { skipGlobalErrorToast: true }),

    // 服务分组
    listGroups: () => get('/groups'),
    createGroup: (data) => post('/groups/create', data),
    updateGroup: (id, data) => post(`/groups/${id}/update`, data),
    deleteGroup: (id) => post(`/groups/${id}/delete`),
    setGroupMember: (id, nodeId, weight) => post(`/groups/${id}/members`, { node_id: nodeId, weight }),
    removeGroupMember: (id, nodeId) => post(`/groups/${id}/members/remove`, { node_id: nodeId }),

    // 抑制名单（含全局）
    listSuppressions: (params) => get('/suppressions', params),
    createSuppression: (data) => post('/suppressions/create', data),
    deleteSuppression: (id) => post(`/suppressions/${id}/delete`),
};

export default tmAdminService;
